import React, { useEffect, useState } from "react";
import hotel from "../../../Assets/propertydetails/hotel1.png";
import man from "../../../Assets/propertydetails/man.svg";
import washroom from "../../../Assets/propertydetails/washroom.svg";
import Aos from "aos";
import "aos/dist/aos.css";

import bed from "../../../Assets/propertydetails/hostelbed.svg";
import axios from "axios";
import { IoWoman } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const SimilarPlace = () => {
  const navigate = useNavigate();
  const [resources, setResources] = useState([]);
  const fetchAllResources = () => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      maxBodyLenght: Infinity,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of fetchAllResoures: ", response.data);
        setResources(response.data.data.slice(0, 3));
      })
      .catch((error) => {
        console.log("Error in fetchAllResources: ", error);
      });
  };

  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Animation happens only once when scrolled into view
    });
    fetchAllResources();
  }, []);
  return (
    <div className="sm:px-16 px-6">
      <h2 className="text-2xl font-semibold mb-6">
        Similar Places You May Like
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {resources?.map((place, index) => (
          <div
            key={index}
            className="bg-white   overflow-hidden"
            data-aos={`fade-${index % 2 === 0 ? "right" : "left"}`}
          >
            <img
              src={place?.images[0] || ""}
              alt={place.name}
              className="w-full rounded-lg object-cover"
            />
            <div className="p-4">
              <div className="flex justify-between lg:items-center sm:items-start items-center lg:flex-row sm:flex-col flex-row">
                <div>
                  <h3 className="text-lg font-semibold">
                    {place.nameBuilding}
                  </h3>
                  <p className="text-gray-600">{place.pgAddress}</p>
                </div>
                {place?.pgType === "Male" ? (
                  <button className="flex items-center  bg-gray-200 px-3 py-1.5 rounded-full text-gray-700 shadow-lg">
                    <img src={man} alt="pg man" />
                    <h1 className="tracking-wide">Men's PG</h1>
                  </button>
                ) : (
                  <button className="flex items-center bg-gray-200 px-3 py-1.5 rounded-full text-gray-700 shadow-lg">
                    <IoWoman size={26} color="black" />
                    <h1 className="tracking-wide">Women's PG</h1>
                  </button>
                )}
              </div>

              <div className="lg:flex sm:hidden flex space-x-2 mt-2 text-gray-600 text-sm">
                {["Single", "Double", "Triple"].map((type) => (
                  <span
                    key={type}
                    className="border px-2 py-1 rounded-full flex items-center gap-1 text-[#929292] bg-[#EEEEEE]"
                  >
                    <img src={bed} alt="bed" />
                    {type}
                  </span>
                ))}
              </div>
              <button
                onClick={() => navigate(`/property-details/${place._id}`)}
                className="w-full mt-4 border border-primaryColor
               text-blue-500 px-4 py-2 rounded hover:bg-primaryBtnHoverColor  hover:text-white transition"
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarPlace;
